import { asArray } from "./as-array";

/**
 * Replaces `item` in array immutably or adds it if it doesn't exist already
 */
const addOrReplace = <T>(params: {
    list: T[];
    itemsToAddOrReplace: T | T[];
    predicate?: (item: T) => unknown;
}): T[] => {
    const { list: items, itemsToAddOrReplace } = params;
    const predicate = params.predicate || ((item: T) => item); // default to comparing whole item
    const input = asArray(itemsToAddOrReplace);
    const notFound = input.filter(
        inp => !items.some(it => predicate(it) === predicate(inp))
    );
    const output = [
        ...items.map(oldItem => {
            const newItem = input.find(
                inp => predicate(inp) === predicate(oldItem)
            );
            return newItem || oldItem;
        }),
        ...notFound,
    ];
    return output;
};

export { addOrReplace };
